module.exports = __webpack_public_path__ + "img/5C.5c014609.jpeg";